import { render, staticRenderFns } from "./systemlog.vue?vue&type=template&id=22044a9a&scoped=true"
import script from "./systemlog.vue?vue&type=script&lang=js"
export * from "./systemlog.vue?vue&type=script&lang=js"
import style0 from "./systemlog.vue?vue&type=style&index=0&id=22044a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22044a9a",
  null
  
)

export default component.exports